@if (authService.hasPermission(Permission.ProductsDownloadWeightsAndMeasures)) {
  <button
    mat-menu-item
    (click)="onDownload()"
    >
    <mat-icon>download</mat-icon>
    <span>Download W&M</span>
  </button>
}
